import { bootstrapAppLogging } from "app-logging-common-js-lib";
import apiInstance from "../utils/api/instance";
import apcApi from "../../api/apcApi";
import mpApiInstance from "../../managepartnership/utils/api/instance";
import uplevelApiInstance from "../../uplevel_renewal/utils/api/instance";
import specializationApiInstance from "../../specialization/utils/api/instance";

let appLoggingReady = false;

/**
 * Same UI_EVENT model as other apps: bootstrap-only (auto clicks + SPA routes + API_LOG via Axios).
 * No manual eventName strings — names come from uiEventName resolution in the library.
 */
export function initApcAppLogging() {
  if (typeof window === "undefined") return;

  const partner = window.apcConfig && window.apcConfig.partner;
  const logBase = partner && partner.logIngestBaseUrl;
  const logIndex = partner && partner.logIngestIndex;
  const logSourceType = partner && partner.logIngestSourceType;
  if (!logBase || !logIndex || !logSourceType) {
    console.warn(
      "[apc logger] partner.logIngestBaseUrl, logIngestIndex, or logIngestSourceType missing; skipping init",
    );
    return;
  }

  if (!appLoggingReady) {
    try {
      bootstrapAppLogging({
        appName: "APC_Onboarding_UI",
        baseUrl: String(logBase).replace(/\/$/, ""),
        splunkIndex: String(logIndex),
        splunkSourceType: String(logSourceType),
        service: "APC_REGISTRATION",
        axiosInstances: [
          apiInstance,
          apcApi,
          mpApiInstance,
          uplevelApiInstance,
          specializationApiInstance,
        ],
        getApiKey: () => window.apcConfig?.adobeIO?.apiKey ?? "",
        navigationTracking: true,
        autoClickTracking: true,
      });
      appLoggingReady = true;
    } catch (e) {
      console.warn("[apc logger] bootstrapAppLogging failed", e);
    }
  }
}

export function initRegistrationLogger() {
  initApcAppLogging();
}
